    /*
  initialize sliders if applicable 
  on current page
  */

export function initSliders() {
    if ($('.m-slider_introslider')) {
        $('.m-slider_introslider').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

        var vid = $('.slick__content .video video')[0];
        vid.onplay = function() {
            $('.m-slider_introslider').slick('slickSetOption', 'autoplay', false).slick('slickPause');
        };

        $('.m-slider_introslider .slick-arrow').on('click', function() {
            vid.pause();
        })
    }

    if ($('.m-partnerslider')) {
        $('.m-partnerslider').slick({
            autoplay: false,
            autoplaySpeed: 5000,
            arrows: false,
            dots: true,
        });
    }

    if ($('.m-slider_fragenquartett')) {
        $('.m-slider_fragenquartett').slick({
            slidesToShow: 3,
            slidesToScroll: 1
        });
    }

    if ($('.m-slider_moderationsprozess')) {
        $('.m-slider_moderationsprozess').slick({
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }
}
